// Lib
import React, { useCallback } from 'react';
import { compose } from 'redux';
import { connect, useDispatch } from 'react-redux';
import makeElementSelector from '../selectors/elementSelector';
import { getCollapsedCommentPopupId } from '../../../common/elements/utils/collapsedCommentPopupUtils';
import CommentThreadCollapsedPopup from '../comment/collapsed/CommentThreadCollapsedPopup';
import elementContainerMapDispatchToProps from '../elementContainerMapDispatchToProps';
import { poiBoardSectionContextConsumer } from '../../components/pointsOfInterest/PoiBoardSectionContext';
import { ImMNElement } from '../../../common/elements/elementModelTypes';
import { finishEditingCurrentElement } from '../selection/selectionActions';
import { stopDefaultAndPropagation } from '../../utils/domUtil';

const INLINE_COMMENT_ARROW_STYLE = { transform: 'translate(-0.6rem, 1px)' };

// Use similar decorators as ElementContainer.jsx
const enhance = compose(
    connect(makeElementSelector, elementContainerMapDispatchToProps),
    poiBoardSectionContextConsumer,
);

type CommentAttachedInlineProps = {
    elementId: string;
    element: ImMNElement;
    currentBoardId: string;
    permissions: number;
    popupCssSelectorPrefix?: string;
};

const CommentAttachedInline: React.FC<CommentAttachedInlineProps> = (props) => {
    const { elementId, popupCssSelectorPrefix = '' } = props;

    const popupId = getCollapsedCommentPopupId(elementId);

    const dispatch = useDispatch();
    const stopEditing = useCallback(() => dispatch(finishEditingCurrentElement()), []);

    return (
        <div onMouseDown={stopEditing} onClick={stopDefaultAndPropagation}>
            <CommentThreadCollapsedPopup
                popupCssSelector={`${popupCssSelectorPrefix}.InlineComment[data-comment-thread-id="${elementId}"]`}
                {...props}
                threadId={elementId}
                offset={-3}
                arrowStyle={INLINE_COMMENT_ARROW_STYLE}
                popupId={popupId}
            />
        </div>
    );
};

const EnhancedCommentAttachedInline = enhance(CommentAttachedInline) as React.FC<CommentAttachedInlineProps>;

export default EnhancedCommentAttachedInline;
